module.exports = __webpack_public_path__ + "static/media/jey.fa323f96.svg";